import { z } from 'zod'

import {
  isoDateSchema,
  nullableString,
  serverItemSchema,
} from '../../utils/schema'
import { profileBaseSchema } from '../../schema/profile.schema'
import { installationDetailSchema } from '../../schema/installation.schema'

type ClientStation = z.infer<typeof clientStationSchema>
type ClientStationStatus = z.infer<typeof clientStationStatus>
type TerminalType = z.infer<typeof terminalType>

const clientStationStatus = z.enum(['canceled', 'completed'])
const terminalType = z.enum(['client', 'pos'])

const clientStationSchema = serverItemSchema.extend({
  cancelledAt: isoDateSchema.nullable(),
  checkedInAt: isoDateSchema.nullable(),
  completedAt: isoDateSchema.nullable(),
  client: profileBaseSchema.nullable(),
  pointsEarned: z.number(),
  rewardsApplied: z.number(),
  station: serverItemSchema
    .extend({
      name: nullableString,
    })
    .nullable(),
})

const stationSchema = serverItemSchema.extend({
  name: z.string(),
})

const activeStationsResponseSchema = z.array(
  stationSchema.and(z.object({ isClient: z.boolean(), isPos: z.boolean() }))
)

const createClientStationResponseSchema = z.object({
  stationClient: serverItemSchema.extend({
    active: z.boolean(),
  }),
})

const stationClientSchema = serverItemSchema.merge(
  z.object({
    active: z.boolean(),
    e164: nullableString,
    email: nullableString,
  })
)

const stationResponseSchema = z.object({ station: stationSchema.nullable() })
const stationsResponseSchema = z.array(
  stationSchema.and(
    z.object({
      installationClient: installationDetailSchema.nullable(),
      installationPos: installationDetailSchema.nullable(),
    })
  )
)

export type { ClientStation, ClientStationStatus, TerminalType }
export {
  activeStationsResponseSchema,
  clientStationSchema,
  createClientStationResponseSchema,
  stationClientSchema,
  stationResponseSchema,
  stationsResponseSchema,
}
